"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationDrawer = void 0;
var react_1 = __importStar(require("react"));
var styles = __importStar(require("./NavigationDrawer.css"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var NavigationMenuItem_1 = require("./NavigationMenuItem");
var DrawerToggleButton_1 = require("./DrawerToggleButton");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var NavigationContext_1 = require("./NavigationContext");
var react_transition_group_1 = require("react-transition-group");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var react_2 = require("react");
var TelemetryContext_1 = require("../Telemetry/TelemetryContext");
var NavigationTheming_css_1 = require("./NavigationTheming.css");
var NavigationTheming_1 = require("./NavigationTheming");
var AuthenticationContext_1 = require("../Springboard/AuthenticationContext");
var RequireAccountPrompt_1 = require("../Springboard/RequireAccountPrompt");
var StoredState_1 = require("../StoredState/StoredState");
var PubSub_1 = require("../PubSub/PubSub");
var zod_1 = require("zod");
var dynamic_1 = require("@vanilla-extract/dynamic");
var SpringboardEngagementViewStoreContext_1 = require("../Springboard/SpringboardEngagementViewStoreContext");
var NavigationDrawer = function (_a) {
    var layout = _a.layout, showDrawer = _a.showDrawer, items = _a.items, mode = _a.mode, pageOwner = _a.pageOwner, backgroundColor = _a.backgroundColor, _b = _a.withEditorInfoBanner, withEditorInfoBanner = _b === void 0 ? false : _b;
    var navigationContext = (0, NavigationContext_1.useNavigationContext)();
    var isOpen = navigationContext.isNavDrawerOpen;
    var track = (0, TelemetryContext_1.useTelemetry)().track;
    var firstMenuItem = (0, react_1.useRef)(null);
    var _c = __read((0, StoredState_1.useLocalStorage)({
        key: "qwilr:open-nav-by-default",
        schema: zod_1.z.boolean(),
        default: false,
    }), 2), openByDefault = _c[0], setOpenByDefault = _c[1];
    var defaultOpenActioned = react_1.default.useRef(false);
    (0, react_2.useEffect)(function () {
        if (openByDefault && !defaultOpenActioned.current) {
            PubSub_1.PubSub.publish("qwilr:nav-drawer-toggled", { isOpen: true });
            setOpenByDefault(false);
            defaultOpenActioned.current = true;
        }
    }, [openByDefault]);
    (0, react_2.useEffect)(function () {
        var projectWrapper = document.querySelector(".project-content-wrapper");
        if (!projectWrapper) {
            return;
        }
        if (showDrawer) {
            projectWrapper.setAttribute("blocks-navigation-enabled", "true");
        }
        else {
            projectWrapper.removeAttribute("blocks-navigation-enabled");
        }
    }, [showDrawer]);
    (0, react_2.useEffect)(function () {
        if (isOpen && !openByDefault) {
            track("Navigation Used", { feature_used: "opened navigation" });
        }
    }, [isOpen, openByDefault]);
    (0, react_2.useEffect)(function () {
        return PubSub_1.PubSub.subscribe("qwilr:nav-drawer-toggled", function (_a) {
            var isOpen = _a.isOpen, reason = _a.reason;
            if (isOpen && reason === "toggle-button-clicked") {
                setTimeout(function () {
                    if (firstMenuItem.current) {
                        firstMenuItem.current.focus({ preventScroll: true });
                    }
                }, 0);
            }
        });
    }, []);
    var _d = __read((0, PubSub_1.usePubSubEvent)("qwilr:content-sidebar-toggled", {
        isOpen: false,
    }), 1), isContentSidebarOpen = _d[0].isOpen;
    if (!navigationContext.showNavWhileEditing || !showDrawer) {
        return null;
    }
    var inlineVars = (0, NavigationTheming_1.getNavThemeInlineVars)(backgroundColor);
    var handleEscapePressed = function (event) {
        if (event.key === utils_1.KeyType.Escape) {
            PubSub_1.PubSub.publish("qwilr:nav-drawer-toggled", { isOpen: false, reason: "escape-pressed-in-drawer" });
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles.outerDrawer({ isOpen: isOpen, layout: layout, mode: mode, withEditorInfoBanner: withEditorInfoBanner }), style: inlineVars, onKeyDown: handleEscapePressed },
            react_1.default.createElement(kaleidoscope_1.Layer, { offset: 2 }, function (_a) {
                var _b;
                var zIndex = _a.zIndex;
                return (react_1.default.createElement("div", { className: styles.drawer({ mode: mode, isOpen: isOpen, layout: layout, isContentSidebarOpen: isContentSidebarOpen, withEditorInfoBanner: withEditorInfoBanner }), style: (0, dynamic_1.assignInlineVars)((_b = {}, _b[styles.layerZIndex] = "".concat(zIndex), _b)) },
                    react_1.default.createElement("div", { className: styles.drawerContent },
                        layout !== "top" && (react_1.default.createElement("div", { className: styles.drawerActions },
                            react_1.default.createElement(kaleidoscope_1.Label, { className: styles.label({ layout: layout }), size: "m" }, "Menu"),
                            react_1.default.createElement("div", { className: styles.drawerButton({ layout: layout, isOpen: isOpen }) },
                                react_1.default.createElement(DrawerToggleButton_1.DrawerToggleButton, null)))),
                        react_1.default.createElement(react_transition_group_1.Transition, { in: isOpen, mountOnEnter: true, unmountOnExit: true, onEnter: utils_1.forceReflow, timeout: 500 }, function (status) { return (react_1.default.createElement("nav", { className: styles.drawerItem({ status: status, type: "body", layout: layout }) },
                            react_1.default.createElement("div", null, items
                                .filter(function (item) { return navigationContext.showHiddenItems || item.show; })
                                .map(function (item, idx) { return (react_1.default.createElement(NavigationMenuItem_1.MenuItem, { label: item.name || item.defaultLabel, blockId: item.blockId, key: item.blockId, ref: idx === 0 ? firstMenuItem : undefined })); })),
                            navigationContext.MenuItemsFooter && react_1.default.createElement(navigationContext.MenuItemsFooter, { items: items }))); })),
                    pageOwner.contactEnabled && (react_1.default.createElement(react_transition_group_1.Transition, { in: isOpen, mountOnEnter: true, unmountOnExit: true, onEnter: utils_1.forceReflow, timeout: 500 }, function (status) { return (react_1.default.createElement("div", { className: styles.drawerItem({ status: status, type: "footer", layout: layout }) },
                        react_1.default.createElement(kaleidoscope_1.Avatar, { firstName: pageOwner.firstName, lastName: pageOwner.lastName, size: kaleidoscope_1.AvatarSize.Large, className: NavigationTheming_css_1.navigationThemeLightOverride }),
                        react_1.default.createElement("div", { className: styles.pageOwnerDetails },
                            react_1.default.createElement(kaleidoscope_1.Text, { size: "xs", lineHeight: "compact" }, pageOwner.organisation),
                            react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s", lineHeight: "compact" },
                                pageOwner.firstName,
                                " ",
                                pageOwner.lastName)),
                        react_1.default.createElement(ContactOwner, { email: pageOwner.email, deferNavOpen: function () {
                                setOpenByDefault(true);
                                defaultOpenActioned.current = true;
                            } }))); }))));
            }))));
};
exports.NavigationDrawer = NavigationDrawer;
var ContactOwner = function (_a) {
    var email = _a.email, deferNavOpen = _a.deferNavOpen;
    var track = (0, TelemetryContext_1.useTelemetry)().track;
    var _b = (0, SpringboardEngagementViewStoreContext_1.useSpringboardEngagementViewStoreContext)(), demoMode = _b.demoMode, showEngagementMenu = _b.showEngagementMenu;
    var isSignedIn = (0, AuthenticationContext_1.useAuthenticationContext)().isSignedIn;
    if (demoMode) {
        return (react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.Mail, null), tooltip: {
                content: "",
                size: kaleidoscope_1.TooltipSize.Large,
            }, disabled: true, disabledReason: "Clients can contact you via email from a live Qwilr page" }));
    }
    if (!showEngagementMenu || isSignedIn) {
        return (react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.Mail, null), tooltip: {
                content: "Send email",
            }, href: function () { return "mailto:".concat(email); }, onClick: function () { return track("Navigation Used", { feature_used: "contacted owner" }); } }));
    }
    return (react_1.default.createElement(kaleidoscope_1.Popover, { padding: "none", autoStack: true, offset: 8, size: kaleidoscope_1.PopoverSize.Large, button: function (buttonProps) {
            return (react_1.default.createElement(kaleidoscope_1.IconButton, __assign({ icon: react_1.default.createElement(icons_1.Mail, null), tooltip: {
                    content: "Send email",
                } }, buttonProps)));
        } },
        react_1.default.createElement(RequireAccountPrompt_1.RequireSpringboardAccountPrompt, { action: "contact owner", deferredAction: deferNavOpen })));
};
